import { createContext, useContext, useEffect, useState } from "react"
import { getFunnels, getLastFunnel } from "../schemas/Funnel"
import { getAllUsersGroup, getUsers } from "../schemas/User"
import { getReasonsDiscard } from "../schemas/ReasonDiscard"
import { getTypesTask } from "../schemas/TypeTask"
import { getAdditionalFields } from "../schemas/AdditionalField"
import { getFlags } from "../schemas/Flag"
import { getRoles } from "../schemas/Role"
import { getTeams } from "../schemas/Team"
import { getCampaignsByOrigins } from "../schemas/Campaign"
import { getOrigins } from "../schemas/Origins"
import { getProducts } from "../schemas/Products"
import { getAllFields } from "../schemas/Field"
import Loading from "../pages/layouts/Loading"
import { useAuth } from "./authContext"
import { getAllAdAccounts, getAllOptionsByMetaAds } from "../schemas/MetaAds"
import { getAllGoogleAdAccounts } from "../schemas/GoogleAds"

const DataContext = createContext()

const DataProvider = ({ children }) => {
    const [accountId, setAccountId] = useState()
    const [lastFunnel, setLastFunnel] = useState(null)
    const [lastFunnelLoaded, setLastFunnelLoaded] = useState(false)
    const [funnels, setFunnels] = useState([])
    const [funnelsLoaded, setFunnelsLoaded] = useState(false)
    const [allUsersGroup, setAllUsersGroup] = useState([])
    const [reasonsDiscard, setReasonsDiscard] = useState([])
    const [typesTask, setTypesTask] = useState([])
    const [additionalFields, setAdditionalFields] = useState([])
    const [teams, setTeams] = useState([])
    const [roles, setRoles] = useState([])
    const [flags, setFlags] = useState([])
    const [flagsByoptions, setFlagsByoptions] = useState([])
    const [users, setUsers] = useState([])
    const [campaigns, setCampaigns] = useState([])
    const [origins, setOrigins] = useState([])
    const [products, setProducts] = useState([])
    const [fields, setFields] = useState([])
    const [adAccounts, setAdAccounts] = useState([])
    const [googleAdAccounts, setGoogleAdAccounts] = useState([])
    const [metaAdsAdsName, setMetaAdsAdsName] = useState([])
    const [metaAdsAdsetsName, setMetaAdsAdsetsName] = useState([])
    const [metaAdsCampaignsName, setMetaAdsCampaignsName] = useState([])
    const [metaAdsFormsName, setMetaAdsFormsName] = useState([])
    const [metaAdsPagesName, setMetaAdsPagesName] = useState([])
    const [countLoading, setCountLoading] = useState(0)

    const { statusAccount, permissions } = useAuth()

    const typeDate = [
        { id: 1, value: "Data do Cadastro", selected: true },
        { id: 2, value: "Data da Tarefa" },
        { id: 3, value: "Data da Venda" },
    ]

    const status = [
        { id: 1, value: "Em Negociação", selected: true },
        { id: 2, value: "Lead Descartado" },
        { id: 3, value: "Venda Realizada" },
    ]

    const addCountLoading = (loading) => {
        if (loading) {
            setCountLoading(previousValue => previousValue + 1)
        }
    }
    const removeCountLoading = (loading) => {
        if (loading) {
            setCountLoading(previousValue => previousValue - 1)
        }
    }
    const loadFunnels = async (loading = false) => {
        try {
            addCountLoading(loading)
            const funnels = await getFunnels()
            setFunnels(funnels)
            return funnels || []
        } catch (err) { } finally {
            setFunnelsLoaded(true)
            removeCountLoading(loading)
        }
    }
    const loadLastFunnel = async (loading = false) => {
        try {
            addCountLoading(loading)

            const funnel = await getLastFunnel()
            if (funnel) {
                setLastFunnel(funnel)
            }
        } catch (err) { } finally {
            setLastFunnelLoaded(true)
            removeCountLoading(loading)
        }
    }
    const updateLastFunnel = async (funnel_id) => {
        setLastFunnel(funnel_id)
    }
    const loadUsers = async (loading = false) => {
        try {
            addCountLoading(loading)
            const users = await getUsers()
            setUsers(users?.map(user => { return { id: user._id, value: user.name } }))
        } catch (err) { } finally {
            removeCountLoading(loading)
        }
    }
    const loadAllUsersGroup = async (loading = false) => {
        try {
            addCountLoading(loading)
            const users = await getAllUsersGroup()
            setAllUsersGroup(users)
        } catch (err) { } finally {
            removeCountLoading(loading)
        }
    }
    const loadReasonsDiscard = async (loading = false) => {
        try {
            addCountLoading(loading)
            const reasons = await getReasonsDiscard()
            setReasonsDiscard(reasons)
        } catch (err) { } finally {
            removeCountLoading(loading)
        }
    }
    const loadTypesTask = async (loading = false) => {
        try {
            addCountLoading(loading)
            const types = await getTypesTask()
            setTypesTask(types)
        } catch (err) { } finally {
            removeCountLoading(loading)
        }
    }
    const loadAdditionalFields = async (loading = false) => {
        try {
            addCountLoading(loading)
            const fields = await getAdditionalFields()
            setAdditionalFields(fields)
        } catch (err) { } finally {
            removeCountLoading(loading)
        }
    }
    const loadTeams = async (loading = false) => {
        try {
            addCountLoading(loading)
            const teams = await getTeams()
            setTeams(teams?.map(team => { return { id: team._id, value: team.name, users: team.users } }))
        } catch (err) { } finally {
            removeCountLoading(loading)
        }
    }
    const loadRoles = async (loading = false) => {
        try {
            addCountLoading(loading)
            const roles = await getRoles()
            setRoles(roles?.map(role => { return { id: role._id, value: role.name } }))
        } catch (err) { } finally {
            removeCountLoading(loading)
        }
    }
    const loadFlags = async (loading = false) => {
        try {
            addCountLoading(loading)
            const flags = await getFlags()
            setFlags(flags)
            setFlagsByoptions(flags?.map(flag => { return { id: flag._id, value: flag.name } }))
        } catch (err) { } finally {
            removeCountLoading(loading)
        }
    }
    const loadCampaignsByOrigins = async (origins, loading = false) => {
        try {
            addCountLoading(loading)
            const campaigns = await getCampaignsByOrigins(origins)
            setCampaigns(campaigns?.map(campaign => { return { id: campaign, value: campaign } })?.filter(campaign => campaign.value))
        } catch (err) { } finally {
            removeCountLoading(loading)
        }
    }
    const loadOrigins = async (loading = false) => {
        try {
            addCountLoading(loading)
            const origins = await getOrigins()
            setOrigins(origins?.map(origin => { return { id: origin._id, value: origin.name } }))
        } catch (err) { } finally {
            removeCountLoading(loading)
        }
    }
    const loadProducts = async (loading = false) => {
        try {
            addCountLoading(loading)
            const products = await getProducts()
            setProducts(products)
        } catch (err) { } finally {
            removeCountLoading(loading)
        }
    }
    const loadFields = async (loading = false) => {
        try {
            addCountLoading(loading)
            const fields = await getAllFields()
            setFields(fields)
        } catch (err) { } finally {
            removeCountLoading(loading)
        }
    }
    const resetAllData = () => {
        setAccountId()
        setLastFunnel()
        setLastFunnelLoaded(false)
        setFunnels([])
        setAllUsersGroup([])
        setReasonsDiscard([])
        setTypesTask([])
        setAdditionalFields([])
        setTeams([])
        setFlags([])
        setFlagsByoptions([])
        setUsers([])
        setCampaigns([])
        setOrigins([])
        setProducts([])
        setFields([])
        setCountLoading(0)
    }
    const loadAdAccounts = async () => {
        const adAccounts = await getAllAdAccounts()
        setAdAccounts(adAccounts.map(adAccount => ({ id: adAccount._id, value: adAccount.ad_account_name })))
        const googleAdAccounts = await getAllGoogleAdAccounts()
        setGoogleAdAccounts(googleAdAccounts.map(adAccount => ({ id: adAccount._id, value: adAccount.descriptive_name || adAccount.customer_id })))
    }
    const loadOptionsByMetaAds = async () => {
        const data = await getAllOptionsByMetaAds()
        const { meta_ads_ad_name, meta_ads_adset_name, meta_ads_campaign_name, meta_ads_form_name, meta_ads_page_name } = data
        setMetaAdsAdsName(meta_ads_ad_name?.map(value => ({ id: value, value: value })) || [])
        setMetaAdsAdsetsName(meta_ads_adset_name?.map(value => ({ id: value, value: value })) || [])
        setMetaAdsCampaignsName(meta_ads_campaign_name?.map(value => ({ id: value, value: value })) || [])
        setMetaAdsFormsName(meta_ads_form_name?.map(value => ({ id: value, value: value })) || [])
        setMetaAdsPagesName(meta_ads_page_name?.map(value => ({ id: value, value: value })) || [])
    }

    useEffect(() => {
        if (accountId) {
            const isRemoteAccess = permissions?.accessByAdmin || permissions?.accessByPartner
            loadFunnels(true)
            loadTeams(true)
            loadRoles(true)
            loadUsers(true)
            loadOrigins()
            loadProducts()
            loadCampaignsByOrigins([])
            loadOptionsByMetaAds()
            loadAdAccounts()
            if (isRemoteAccess || statusAccount?.hasPermission || permissions?.is_admin > 0) {
                loadLastFunnel(true)
                loadReasonsDiscard()
                loadTypesTask()
                loadAdditionalFields()
                loadFlags(true)
                loadAllUsersGroup(true)
                loadFields()
            }
        }
    }, [accountId, statusAccount?.hasPermission, permissions?.is_admin, permissions?.accessByAdmin, permissions?.accessByPartner])

    return (
        <DataContext.Provider value={{ funnels, funnelsLoaded, lastFunnel, lastFunnelLoaded, allUsersGroup, reasonsDiscard, typesTask, additionalFields, teams, roles, flags, flagsByoptions, fields, users, campaigns, origins, products, typeDate, status, adAccounts, googleAdAccounts, metaAdsAdsName, metaAdsAdsetsName, metaAdsCampaignsName, metaAdsFormsName, metaAdsPagesName, setAccountId, loadFunnels, loadCampaignsByOrigins, updateLastFunnel, resetAllData }}>
            {children}
            {countLoading > 0 && <Loading fullPage={true} initialLoad={true} />}
        </DataContext.Provider>
    )
}

const useData = () => {
    const context = useContext(DataContext)
    return context
}

export { DataProvider, useData }

export default DataProvider
